import { FormActionButton } from '@workwave-tidal/core/form'

import { form } from '../formState'

import { useTexts } from './useTexts'

type Props = {
  ordersCount: number
  handleCancel: () => void
}

export function Footer(props: Props) {
  const { ordersCount, handleCancel } = props

  const texts = useTexts()

  const {
    meta: { submitting, validating, status },
  } = form.useFormMeta()

  const saveDisabled = status === 'pristine' || validating || submitting

  return (
    <>
      <FormActionButton
        label={texts.cancel}
        onClick={handleCancel}
        testId="footer-secondary-button"
        data-trackid="footer-secondary-button"
      />
      <FormActionButton
        label={texts.save(ordersCount)}
        variant="contained"
        type="submit"
        disabled={saveDisabled}
        loading={submitting || validating}
        testId="footer-primary-button"
        data-trackid="footer-primary-button"
      />
    </>
  )
}
